<template>
  <div>
    <ServiceCouponsList
        v-if="!!parseInt(1)"
        :id="parseInt(1)"
        @serviceCouponsItems="serviceCouponsItems"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import ServiceCouponsList from './ServiceCouponsList'

export default {
  name: "ServiceCouponsManagement",
  data() {
    return {
      serviceCouponsItems:[],
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      // "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
    ])
  },
  components: {
    ServiceCouponsList
  },
  mounted() {
  }
};
</script>

<style scoped>
.dropdown-menu {
  min-width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/Service/ServiceCouponsManagement.vue